import Fuels from "../../../../pages/Masters/Fuels";
import FuelsNewEdit from "../../../../pages/Masters/Fuels/NewEdit";
import FuelDetail from "../../../../pages/Masters/Fuels/Detail";

const routerFuel = [
    {
        key: "fuel",
        path: "/masters/fuels",
        element: <Fuels />,
    },
    {
        key: "fuel",
        path: "/masters/fuels/new",
        element: <FuelsNewEdit />,
    },
    {
        key: "fuel",
        path: "/masters/fuels/:id",
        element: <FuelDetail />,
    },
]

export default routerFuel
